// Actions for Insights Keywords
import { createAction, props } from '@ngrx/store';
import { InsightsKeyword } from './state';

// Actions for Get Insights Keywords
export const getInsightsKeywords = createAction('[API] GET InsightsKeywords');
export const getInsightsKeywordsSuccess = createAction('[API] GET InsightsKeywords SUCCESS', props<{ keywords: InsightsKeyword[] }>());
export const getInsightsKeywordsFailure = createAction('[API] GET InsightsKeywords FAILURE', props<{ error: string }>());

// Actions for Post Insights Keywords 
export const addInsightsKeyword = createAction('[API] ADD InsightsKeyword', props<{ keyword: string }>());
export const addInsightsKeywordSuccess = createAction('[API] ADD InsightsKeyword SUCCESS', props<{ message: string }>());
export const addInsightsKeywordError = createAction('[API] ADD InsightsKeyword ERROR', props<{ error: string }>());
